<div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
    <div fxLayoutAlign="flex-start center" class="mb-12 shrink-0">
        <h3 class="mb-0 mt-0">{{ 'GENERAL.PROPERTY.STATUS' | translate }}</h3>
    </div>

    <div class="w-100-p table-wrapper white" *ngIf="dataSource">
        <mat-table #table [dataSource]="dataSource.data" matSort>
            <ng-container matColumnDef="name">
                <mat-header-cell class="pl-24 pr-8" *matHeaderCellDef></mat-header-cell>

                <mat-cell #nameCell *matCellDef="let status" class="pl-24 pr-8" fxLayout="column" fxLayoutAlign="center start">
                    <span class="text-truncate font-semibold w-100-p">{{ status.value | getStatusByValue: certificateStatuses:'translationLabel' | translate }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>

                <mat-cell *matCellDef="let status">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(status); onSelection()" *ngIf="!status.selected"></app-flat-button>

                        <app-white-button
                            [label]="'GENERAL.BUTTON.UNSELECT'"
                            (onClick)="removeFromList(status); onSelection()"
                            *ngIf="status.selected"
                        ></app-white-button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <mat-row *matRowDef="let status; columns: displayedColumns" matRipple></mat-row>
        </mat-table>
    </div>
</div>
